import { MapPin, PhoneCall, Siren, MapPinned } from "lucide-react";
import { motion } from "framer-motion";
import { staggerContainer, staggerItem } from "@/components/motion/Reveal";

const FEATURES = [
  {
    icon: MapPin,
    title: "Ubicación en tiempo real",
    text: "Abre la app y ve dónde está, al instante. Sin mapas complicados ni jerga técnica.",
  },
  {
    icon: PhoneCall,
    title: "Llamadas y mensajes de voz",
    text: "Solo con los contactos que tú apruebas. Nadie más puede llamar a tu hijo.",
  },
  {
    icon: Siren,
    title: "Botón SOS",
    text: "Un toque prolongado avisa a toda la familia con su ubicación exacta.",
  },
  {
    icon: MapPinned,
    title: "Zonas seguras",
    text: "Recibe un aviso amable cuando llega al cole o sale del parque. Tú eliges dónde.",
  },
];

export default function Features() {
  return (
    <section className="bg-[#F3F2F2] border-b-2 border-[#12263A]">
      <div className="max-w-6xl mx-auto px-5 py-20 md:py-28">
        <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#2E9EF0]">Todo lo que importa</span>
        <h2 className="mt-3 text-[28px] md:text-[44px] font-black text-[#12263A] leading-[1.05] max-w-2xl" style={{ letterSpacing: "-0.02em" }}>
          Libertad para tu hijo. Tranquilidad para ti.
        </h2>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6"
        >
          {FEATURES.map(({ icon: Icon, title, text }) => (
            <motion.div
              key={title}
              variants={staggerItem}
              data-testid="feature-card"
              className="bg-white border-2 border-[#12263A] p-7 flex flex-col gap-4 hover:-translate-y-1 transition-transform"
              style={{ borderRadius: "28px" }}
            >
              <div
                className="w-12 h-12 flex items-center justify-center bg-[#F3F2F2] border-2 border-[#12263A]"
                style={{ borderRadius: "31%" }}
              >
                <Icon size={24} strokeWidth={2} className="text-[#12263A]" />
              </div>
              <h3 className="text-[19px] font-black text-[#12263A] leading-snug">{title}</h3>
              <p className="text-[15px] leading-[1.6] text-[#2A3D52]">{text}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
